import { render, staticRenderFns } from "./AwaitSupplier.vue?vue&type=template&id=2a8db74a&"
import script from "./AwaitSupplier.vue?vue&type=script&lang=js&"
export * from "./AwaitSupplier.vue?vue&type=script&lang=js&"
import style0 from "./AwaitSupplier.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports